<template>
    <div>
        <img src="../assets/logo.jpg">
        <h1>Thank you for your Purchase!</h1>
       <h2>Your Confirmation number:</h2>
       <h2>{{$route.params.id}}</h2>
        <!-- <button @click="assumePaid">Here</button> -->
        <a href="https://sv.camp" id='link'>Return to SV.Camp</a>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    methods: {
        assumePaid(){
            const data = {
                fullName: localStorage.fullName,
                age: localStorage.age,
                parentName: localStorage.parentName,
                email: localStorage.email,
                whatsapp: localStorage.whatsapp,
                message: localStorage.message
            }
            console.log(data)
            axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
            axios.post('https://us-central1-svcamp-6d3c3.cloudfunctions.net/api/paid', data)
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }, mounted() {
        this.assumePaid();
    }
}
</script>
<style>
img {
  margin: auto;
  margin-top: 10px;
  width: 25%;
  /* border: 3px solid green; */
  padding: 0px;
}
#link {
    color:blue;
}
</style>